export let baseURL = process.env.REACT_APP_APIURL || "./api/";

export const accessHeader = (token, headers) => {
  let headerValues = {
    headers: {
      "Authorization": "Bearer " + token
    }
  };

  if (headers) {
    headerValues.headers = { ...headers, ...headerValues.headers };
  }
  return headerValues;
}
